/**
 * This file is shared between spd-core & spd-web
 * If you have to change it then do it in spd-core and run yarn get:validation-schemas @spd-web
 */
import * as yup from 'yup';

import { JudgmentNumberingTypeEnum, VatEnum } from './enums';

export enum ParamsTypeEnum {
  String = 'String',
  Boolean = 'Boolean',
  Number = 'Number',
  Date = 'Date',
}

export enum ParamsGroupEnum {
  SYS = 'SYS',
  Reports = 'Reports',
  Invoicing = 'Invoicing',
}

export enum ParamsGroupObj {
  SYS = 'Systemowe',
  Reports = 'Zestawienia',
  Invoicing = 'Fakturowanie',
}

export enum ParamsNameEnum {
  JudgmentsLookbackMonths = 'JudgmentsLookbackMonths',
  TopCompaniesLimit = 'TopCompaniesLimit',
  ReportLastDays = 'ReportLastDays',
  FaceIdentityRetentionDays = 'FaceIdentityRetentionDays',
  AutomaticJudgmentDelayMinutes = 'AutomaticJudgmentDelayMinutes',
  ReferralFreshnessMonths = 'ReferralFreshnessMonths',
  AutomaticJudgmentRequireSignedExternalReferral = 'AutomaticJudgmentRequireSignedExternalReferral',
  WithoutJudgmentDays = 'WithoutJudgmentDays',
  AutoInvoiceMaxApprovalAmount = 'AutoInvoiceMaxApprovalAmount',
  AutoInvoiceDefaultPaymentDays = 'AutoInvoiceDefaultPaymentDays',
  AutoInvoiceErrorEmail = 'AutoInvoiceErrorEmail',
  AutoInvoiceDeadlineDayOfMonth = 'AutoInvoiceDeadlineDayOfMonth',
  SynevoOrderFee = 'SynevoOrderFee',
}

export const ParamsNameObj = {
  JudgmentsLookbackMonths: 'Liczba miesięcy wstecz do generowania orzeczeń',
  TopCompaniesLimit: 'Liczba największych firm w zestawieniach',
  ReportLastDays: 'Liczba dni dla zestawień dziennych',
  FaceIdentityRetentionDays:
    'Liczba dni, po upływie których usuwane są załączniki z identyfikacją badanych',
  AutomaticJudgmentDelayMinutes:
    'Opóźnienie automatycznego wystawienia orzeczeń i kart (w minutach)',
  ReferralFreshnessMonths:
    'Liczba miesięcy, w ciągu których skierowanie musi być dodane do systemu przy automatycznym wystawianiu orzeczeń',
  AutomaticJudgmentRequireSignedExternalReferral:
    'Automatyczne wystawianie orzeczeń tylko dla skierowań zewnętrznych z podpisem',
  WithoutJudgmentDays:
    'Liczba dni wstecz dla listy badań bez orzeczeń (0 = bez limitu)',
  AutoInvoiceMaxApprovalAmount:
    'Maks. kwota faktury do automatycznego zatwierdzenia',
  AutoInvoiceDefaultPaymentDays: 'Domyślna liczba dni płatności faktury',
  AutoInvoiceErrorEmail:
    'Email do powiadomień o błędach automatycznego fakturowania',
  AutoInvoiceDeadlineDayOfMonth:
    'Ostatni dzień miesiąca na automatyczne wystawienie faktury za poprzedni miesiąc (1–28)',
  SynevoOrderFee: 'Opłata za wysłanie zlecenia Synevo (0 = brak opłaty)',
};

export enum ValueTypeEnum {
  String = 'string',
  StringList = 'stringList',
  File = 'file',
  PNG = 'png',
  Webm = 'webm',
  Stetho = 'stetho',
  Audiometry = 'audiometry',
  AudiometryList = 'audiometryList',
  Spiro = 'spiro',
  HarmfulFactorList = 'harmfulFactorList',
  RawECG = 'rawECG',
  ResultsECG = 'resultsECG',
}

export enum JobTypeEnum {
  OrderSynevoDownload = 'OrderSynevoDownload',
  KsefUpoPoll = 'KsefUpoPoll',
  SimP1JudgmentSend = 'SimP1JudgmentSend',
  FaceIdentityRetention = 'FaceIdentityRetention',
  AutomaticJudgment = 'AutomaticJudgment',
  AttachmentObjectStorageMigration = 'AttachmentObjectStorageMigration',
  InvoicePaymentReminder = 'InvoicePaymentReminder',
  TfaCleanup = 'TfaCleanup',
  AutoInvoiceGeneration = 'AutoInvoiceGeneration',
}

export enum JobTypeObj {
  OrderSynevoDownload = 'Pobieranie zamówień z Synevo',
  KsefUpoPoll = 'Wysyłanie faktur do KSeF',
  SimP1JudgmentSend = 'Wysyłanie orzeczeń do P1',
  FaceIdentityRetention = 'Usuwanie załączników z identyfikacją badanych',
  AutomaticJudgment = 'Automatyczne wystawianie orzeczeń',
  AttachmentObjectStorageMigration = 'Przenoszenie załączników do Object Storage',
  InvoicePaymentReminder = 'Przypomnienie o płatności faktury',
  TfaCleanup = 'Czyszczenie wygasłych danych 2FA',
  AutoInvoiceGeneration = 'Automatyczne wystawianie faktur',
}

export enum HarmfulFactorCategory {
  Biological = 'Biological',
  Chemical = 'Chemical',
  Physical = 'Physical',
  Other = 'Other',
  Learn = 'Learn',
}

export enum HarmfulFactorCategoryText {
  Biological = 'Czynniki biologiczne',
  Chemical = 'Czynniki chemiczne',
  Physical = 'Czynniki fizyczne',
  Other = 'Inne czynniki, w tym niebezpieczne',
  Learn = 'Nauka/studia',
}

export enum Healthcare {
  Doctor = 'Doctor',
  Dentist = 'Dentist',
  Midwife = 'Midwife',
  Nurse = 'Nurse',
}

export enum HealthcareText {
  Doctor = 'Lekarz/Lekarka',
  Dentist = 'Stomatolog',
  Midwife = 'Położny/Położna',
  Nurse = 'Pielęgniarz/Pielęgniarka',
}

export enum CardType {
  Preventive = 'Preventive',
  Psychologist = 'Psychologist',
  PsychologistWeapon = 'PsychologistWeapon',
  Weapon = 'Weapon',
  Driver = 'Driver',
  Sanitary = 'Sanitary',
  Sport = 'Sport',
}

export enum CardTypeText {
  Preventive = 'Profilaktyczna',
  Psychologist = 'Psychologiczna',
  PsychologistWeapon = 'Psychologiczna na broń',
  Weapon = 'Broń/Zawody specjalne',
  Driver = 'Kierowcy',
  Sanitary = 'Sanitarno-epidemiologiczna',
  Sport = 'Sportowa',
}

export enum CardTypeLabelEditText {
  Preventive = 'Karta profilaktyczna',
  Psychologist = 'Karta psychologiczna',
  PsychologistWeapon = 'Karta psychologiczna na broń',
  Weapon = 'Karta broń',
  Driver = 'Karta kierowcy',
  Sanitary = 'Karta sanitarno-epidemiologiczna',
  Sport = 'Karta sportowa',
}

export enum CardTypeLabelPrintText {
  Preventive = 'Wydruk karty profilaktycznej',
  Psychologist = 'Wydruk karty psychologicznej',
  PsychologistWeapon = 'Wydruk karty psychologicznej na broń',
  Weapon = 'Wydruk karty na broń',
  Driver = 'Wydruk karty kierowcy',
  Sanitary = 'Wydruk karty sanitarno-epidemiologicznej',
  Sport = 'Wydruk karty sportowej',
}

export enum ConsultationType {
  Neurological = 'Neurological',
  Ophthalmologist = 'Ophthalmologist',
  ENT = 'ENT',
  Psychiatric = 'Psychiatric',
}

export enum ConsultationTypeText {
  Neurological = 'neurologiczna',
  Ophthalmologist = 'okulistyczna',
  ENT = 'laryngologiczna',
  Psychiatric = 'psychiatryczna',
}

export enum Gender {
  Male = 'male',
  Female = 'female',
}

export enum GivingExamMode {
  Examined = 'examined',
  PsychologistFast = 'psychologistFast',
  PsychologistFull = 'psychologistFull',
}

export enum IndicatorTestMode {
  NumberOfCorrectAnswers = 'NumberOfCorrectAnswers',
  SumOfPresentationTime = 'SumOfPresentationTime',
  WeightedSum = 'WeightedSum',
  WeightedValueSum = 'WeightedValueSum',
}

export enum IndicatorTestModeText {
  NumberOfCorrectAnswers = 'Liczba poprawnych odpowiedzi',
  SumOfPresentationTime = 'Czas wykonania',
  WeightedSum = 'Suma ważona',
  WeightedValueSum = 'Suma ważona (wartości)',
}

export enum ArticleMode {
  Doctor = 'Doctor',
  Psychologist = 'Psychologist',
  Ophthalmologist = 'Ophthalmologist',
  Neurologist = 'Neurologist',
  Psychiatrist = 'Psychiatrist',
  Laryngologist = 'Laryngologist',
}

export enum ExamArticleType {
  Doctor = 'Doctor',
  Psychologist = 'Psychologist',
}

export enum LegalBasisType {
  Art43Art229 = 'Art43Art229',
}

export enum LegalBasisTypeText {
  Art43Art229 = 'art. 43 pkt 2 i art. 229 § 4 KP',
}

export enum ArticleModeText {
  Doctor = 'Lekarz',
  Psychologist = 'Psycholog',
  Ophthalmologist = 'Okulista',
  Neurologist = 'Neurolog',
  Psychiatrist = 'Psychiatra',
  Laryngologist = 'Laryngolog',
}

export enum PrintDefMode {
  Referral = 'Referral',
}

export enum PrintDefModeText {
  Referral = 'Skierowanie',
}

export enum ExamPackageType {
  Single = 'Single',
  Mulitiple = 'Mulitiple',
}

export enum ExamPackageMode {
  Exams = 'Exams',
  Normalization = 'Normalization',
}

export enum ExamPackageModeText {
  Exams = 'Badania',
  Normalization = 'Normalizacja',
}

export enum ExaminationType {
  Initial = 'Initial',
  Periodic = 'Periodic',
  Control = 'Control',
  PeriodicControl = 'PeriodicControl',
}

export enum ExaminationTypeText {
  Initial = 'wstępne',
  Periodic = 'okresowe',
  Control = 'kontrolne',
  PeriodicControl = 'okresowo-kontrolne',
}

export enum KindOfScience {
  Apprenticeship = 'Apprenticeship',
  VocationalCourse = 'VocationalCourse',
  Studies = 'Studies',
  DoctoralStudies = 'DoctoralStudies',
}

export enum KindOfScienceText {
  Apprenticeship = 'Praktyczna nauka zawodu',
  VocationalCourse = 'Kwalifikacyjny kurs zawodowy',
  Studies = 'Studia',
  DoctoralStudies = 'Studia doktoranckie',
}

export enum SupportingType {
  helpExam = 'helpExam',
  specialisedConsultation = 'specialisedConsultation',
}

export enum SupportingTypeText {
  helpExam = 'Badanie pomocnicze',
  specialisedConsultation = 'Konsultacja specjalistyczna',
}

export enum ExamWhoExamined {
  Student = 'Student',
  Employee = 'Employee',
  Sanitary = 'Sanitary',
  EmployeeAndSanitary = 'EmployeeAndSanitary',
  StudentAndSanitary = 'StudentAndSanitary',
  SanitaryStudent = 'SanitaryStudent',
}

export enum ExamWhoExaminedText {
  Student = 'Student / uczeń',
  Employee = 'Pracownik / kandydat do pracy',
  Sanitary = 'Do celów sanitarnych dla: Pracownik / kandydat do pracy',
  EmployeeAndSanitary = 'Połączone: Pracownik / kandydat do pracy oraz Do celów sanitarnych',
  StudentAndSanitary = 'Połączone: Student / uczeń oraz Do celów sanitarnych',
  SanitaryStudent = 'Do celów sanitarnych dla: Student / uczeń',
}

export enum TakenCareOf {
  Employee = 'Employee',
  Outwork = 'Outwork',
  Student = 'Student',
  OwnRequest = 'OwnRequest',
}

export enum TakenCareOfText {
  Employee = 'Pracownik',
  Outwork = 'Wykonujący pracę nakładczą',
  Student = 'Pobierający naukę',
  OwnRequest = 'Na własny wniosek',
}

export enum SellDocumentType {
  Paragon = 'Paragon',
  Faktura = 'Faktura',
}

export enum PositionNormMode {
  Centile = 'centyl',
  Decile = 'ten',
  Percentile = 'sten',
  Stanine = 'stanin',
  Standardized = 'przeliczony',
}

export enum StampType {
  Big = 'Big',
  Small = 'Small',
  Double = 'Double',
  Signature = 'Signature',
}

export enum SignatureStatus {
  ToSign = 'ToSign',
  Signed = 'Signed',
  Unnecessary = 'Unnecessary',
}

export enum RegisterMode {
  OK = 'OK', //Psycholodzy - Orzeczenia kierowców
  KMP = 'KMP', //Psycholodzy - Konsultacje medycyny pracy
  BR = 'BR', //Psycholodzy - Badania dot. broni
  K75 = 'K75', //Lekarze - Kierowcy z art. 75
  K43 = 'K43', //Lekarze - Medycyna pracy art. 43
  KS = 'KS', //Lekarze - Sanitarny
  KU = 'KU', //Lekarze - Uczniowie i studenci
  LBR = 'LBR', //Lekarze - Badania dot. broni
}

export const RegisterPsychologist = Object.values(RegisterMode).filter(
  mode =>
    mode === RegisterMode.OK ||
    mode === RegisterMode.KMP ||
    mode === RegisterMode.BR,
) as RegisterMode[];

export enum DrivingLicenseCategory {
  A = 'A',
  A1 = 'A1',
  A2 = 'A2',
  AM = 'AM',
  B = 'B',
  B_E = 'B+E',
  B1 = 'B1',
  C = 'C',
  C_E = 'C+E',
  C1 = 'C1',
  C1_E = 'C1+E',
  D = 'D',
  D_E = 'D+E',
  D1 = 'D1',
  D1_E = 'D1+E',
  T = 'T',
  Tramway = 'Tramwaj',
}

export enum TemplateType {
  Popular_art_82_ust_1 = 'art_82_ust_1',
  Emergency_art_82 = 'art_82_uprzywilejowany',
  Instructor_art_82 = 'art_82_instruktor_egzaminator',
  Road_transport_art_39 = 'art_39_transport_drogowy',
  Occupational_health = 'medycyna_pracy',
  Psychological_Exam_card = 'karta_badania_psychologicznego',
  Weapon_card = 'karta_broni',
  Weapon_medical_judgment = 'bron_orzeczenie_lekarskie',
  Weapon_psychological_judgment = 'bron_orzeczenie_psychologiczne',
  Weapon_psychological_exam_card = 'bron_karta_badania_psychologicznego',
  Preventive_Exam_card = 'karta_badania_profilaktycznego',
  Medical_judgment_43 = 'mp_orzeczenie_lekarskie_43',
  Medical_judgment_43_eng = 'mp_orzeczenie_lekarskie_43_ang',
  Medical_judgment_43_transport = 'mp_orzeczenie_lekarskie_43_transport',
  Medical_judgement_driver_75_6 = 'kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany',
  Medical_judgement_driver_75_all = 'kierowca_orzeczenie_lekarskie_art_75_reszta',
  Medical_judgment_student = 'mp_zaswiadczenie_lekarskie_student',
  Sanitary_judgment = 'orzeczenie_sanitarno_epidemiologiczne',
  Driver_Exam_card = 'karta_badania_kierowcy',
  Neurological_consultation = 'konsultacja_neurologiczna',
  ENT_consultation = 'konsultacja_laryngologiczna',
  Ophthalmologist_consultation = 'konsultacja_okulistyczna',
  Psychiatric_consultation = 'konsultacja_psychiatryczna',
  Answers_card = 'karta_odpowiedzi',
  Sanitary_Exam_card = 'karta_badania_sanitarno_epidemiologicznego',
  Medical_judgment_ability_to_work = 'zaswiadczenie_lekarskie_zdolnosci_do_pracy',
  Sport_certificate = 'zaswiadczenie_sportowe',
  Sport_card = 'karta_badania_sportowego',
  Doctor_ability_to_work = 'orzeczenie_stan_zdrowia_lekarza',
  Nurse_ability_to_work = 'zaswiadczenie_stan_zdrowia_pielegniarka',
  Nurse_ability_to_work_art_31 = 'zaswiadczenie_stan_zdrowia_pielegniarka_art31',
  RegisterJudgment = 'rejestrOrzeczen',
  RegisterOccupationalMedicine = 'rejestrMedycynaPracy',
  RegisterJudgmentDrivers = 'rejestrKierowcow',
  RegisterStudents = 'rejestrUczniowieStudenci',
  Referral_student = 'skierowanie_uczen',
  Referral_student_sanitary = 'skierowanie_uczen_sanitarne',
  Referral_employee = 'skierowanie_pracownik',
  Referral_employee_sanitary = 'skierowanie_pracownik_sanitarne',
  Twilight_vision = 'wynik_widzenia_zmierzchowego',
  Explosives_civil_medical_judgment = 'wybuch_cywilne_orzeczenie_lekarskie',
  Explosives_civil_psychological_judgment = 'wybuch_cywilne_orzeczenie_psychologiczne',
  Explosives_army_medical_judgment = 'wybuch_wojsko_orzeczenie_lekarskie',
  Explosives_army_psychological_judgment = 'wybuch_wojsko_orzeczenie_psychologiczne',
  Detective_medical_judgment = 'detektyw_orzeczenie_lekarskie',
  Detective_psychological_judgment = 'detektyw_orzeczenie_psychologiczne',
  ReportJudgments = 'zestawienie_orzeczen',
  Companies = 'lista_firm',
  ClinicReferral = 'skierowanie_do_poradni',
  Firefighter_medical_judgment = 'strazak_orzeczenie_lekarskie',
  Sports_driver_psychological_judgment = 'kierowca_rajdowy_orzeczenie_psychologiczne',
  Teacher_health_judgment = 'nauczyciel_poratowanie_zdrowia',
  Glasses_judgment = 'zaswiadczenie_okulary',
  Invoice_PL = 'faktura_pl',
  Correction_PL = 'korekta_pl',
}

export enum OccupationalMedicineCategory {
  CatA = 'kierowca pojazdu służbowego kat A',
  CatB = 'kierowca pojazdu służbowego kat B',
  Forklift = 'operator wózka widłowego',
  ReachTrack = 'operator wózka wysokiego składowania',
  HDSCrane = 'operator dźwigu HDS',
  Crane = 'operator żurawia',
  ConstructionMachinery = 'operator maszyn budowlanych ( koparka, ładowarka, zgarniarka, inne)',
  BasketLift = 'operator podnośnika koszowego',
  Gantry = 'operator suwnicy',
  PsychomotorSkills = 'praca wymagająca szczególnej sprawności psychoruchowej',
  Others = 'inne',
  DarkRoom = 'pomiar wrażliwości na olśnienie i widzenia zmierzchowego (ciemnia)',
  Stereoscopic = 'pomiar widzenia stereoskopowego',
}

export enum AttachmentType {
  LaboratoryExamination = 'Badanie laboratoryjne',
  Referral = 'Skierowanie',
  ExternalReferral = 'Skierowanie zewnętrzne',
  Judgment = 'Orzeczenie',
  JudgmentEng = 'Orzeczenie angielskie',
  FaceIdentity = 'Identyfikacja badanego',
  Diabetologist = 'Zaświadczenie od diabetologa',
  ReferralOthers = 'Skierowanie ze Starostwa/Policji',
  InvoiceAttachment = 'Załącznik do faktury',
  ManualAttachment = 'Załącznik do podręcznika',
}

export enum EmailType {
  Judgment = 'Orzeczenie',
  JudgmentEng = 'Orzeczenie angielskie',
  Referral = 'Skierowanie',
  ExternalReferral = 'Skierowanie zewnętrzne',
  SynevoReferral = 'Skierowanie Synevo',
  AppointmentConfirmation = 'Potwierdzenie wizyty',
  PsychologicalExamResult = 'Wynik badania psychologicznego',
  PaymentSuccess = 'Potwierdzenie płatności',
  PaymentFailed = 'Informacja o płatności',
  CriticalPoint = 'Badanie, uzupełnienie dokumentów',
  OnlineExam = 'Zlecono badanie online',
  SalesInvoice = 'Faktura sprzedaży',
  EParagon = 'E-Paragon',
  InvoicePaymentReminder = 'Przypomnienie o płatności',
  TwoFactorCode = 'Kod weryfikacyjny 2FA',
  AutoInvoiceSummary = 'Podsumowanie automatycznego fakturowania',
  JudgmentCancellation = 'Anulowanie orzeczenia',
}

export enum EmailStatus {
  NotSent = 'NotSent',
  Sent = 'Sent',
  Error = 'Error',
}

export enum EmailStatusText {
  NotSent = 'Niewysłany',
  Sent = 'Wysłany',
  Error = 'Błąd',
}

export enum PaymentStatus {
  Created = 'Created',
  Pending = 'Pending',
  Cancelled = 'Cancelled',
  Error = 'Error',
  Success = 'Success',
  Returned = 'Returned',
}

export enum PaymentType {
  Cash = 'Gotówka',
  Card = 'Karta',
  Transfer = 'Przelew',
  Mobile = 'Płatność mobilna',
}

const digits = /^[0-9]+$/;

function digitsOnly(text: string | null | undefined) {
  if (!text) {
    return true;
  }

  if (!text.match(digits)) {
    return false;
  }
  return true;
}

// function validNip(nip: string | null | undefined) {
//   if (!nip) {
//     return true;
//   }

//   if (typeof nip !== 'string') {
//     return false;
//   }

//   nip = nip.replace(/[ -]/gi, '');
//   if (nip.length !== 10) {
//     return false;
//   }
//   const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
//   let sum = 0;
//   const controlNumber = parseInt(nip.substring(9, 10));
//   const weightCount = weight.length;
//   for (let i = 0; i < weightCount; i++) {
//     sum += parseInt(nip.substr(i, 1)) * weight[i];
//   }
//   return sum % 11 === controlNumber;
// }

export const getBirthDateFromPesel = (pesel: string) => {
  let year = parseInt(pesel.substring(0, 2), 10);
  let month = parseInt(pesel.substring(2, 4), 10) - 1;
  const day = parseInt(pesel.substring(4, 6), 10);

  if (month >= 80) {
    year += 1800;
    month = month - 80;
  } else if (month >= 60) {
    year += 2200;
    month = month - 60;
  } else if (month >= 40) {
    year += 2100;
    month = month - 40;
  } else if (month >= 20) {
    year += 2000;
    month = month - 20;
  } else {
    year += 1900;
  }

  const birthDate = new Date(Date.UTC(year, month, day));
  return birthDate;
};

export const getSexFromPesel = (pesel: string) => {
  const sexDigit = parseInt(pesel.charAt(9), 10);

  if (sexDigit % 2 === 0) {
    return 'female';
  } else {
    return 'male';
  }
};

export const isPeselAndBirthDateValid = (
  pesel?: string | null,
  birthDate?: Date | null,
) => {
  if (pesel && birthDate && pesel.length === 11) {
    birthDate.setUTCHours(0, 0, 0, 0);
    return (
      getBirthDateFromPesel(pesel).toISOString() === birthDate.toISOString()
    );
  } else {
    return true;
  }
};

export const isPeselValid = (pesel?: string | null) => {
  if (!pesel) {
    return true;
  }

  if (typeof pesel !== 'string') {
    return false;
  }

  pesel = pesel.replace(/[ -]/gi, '');
  if (pesel.length !== 11) {
    return false;
  }

  const weight = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7];
  let sum = 0;

  for (let i = 0; i < weight.length; i++) {
    sum += parseInt(pesel.substring(i, i + 1), 10) * weight[i];
  }

  sum = sum % 10;

  const controlDigit = parseInt(pesel.substring(10, 11), 10);
  return sum === controlDigit;
};

export const isNipValid = (nip?: string | null) => {
  if (!nip || nip.length === 0) {
    return true;
  }

  nip = nip.replace(/[ -]/gi, '');

  if (/^[a-zA-Z]{2}/.test(nip)) {
    const code = nip.substring(0, 2).toUpperCase();
    if (!(code in EU_VAT_PATTERNS)) {
      return false;
    }
    return isEuVatValid(nip);
  }

  if (/[a-zA-Z]/.test(nip)) {
    return false;
  }

  if (nip.length !== 10) {
    return false;
  }

  const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  let sum = 0;
  const controlNumber = parseInt(nip.substring(9, 10), 10);

  for (let i = 0; i < weight.length; i++) {
    sum += parseInt(nip.substring(i, i + 1), 10) * weight[i];
  }

  return sum % 11 === controlNumber;
};

export const getGenderFromPesel = (pesel: string) => {
  let gender = Gender.Female;
  if (parseInt(pesel.substring(9, 10), 10) % 2 === 1) {
    gender = Gender.Male;
  }
  return gender;
};

const dateNotFuture = (value: Date | null | undefined) => {
  if (!value) {
    return true;
  }

  const v = new Date(value);
  const today = new Date();

  // Compare UTC dates only, with +1 day leeway for UTC+ timezone users
  const vDay = Date.UTC(v.getUTCFullYear(), v.getUTCMonth(), v.getUTCDate());
  const tomorrowDay = Date.UTC(
    today.getUTCFullYear(),
    today.getUTCMonth(),
    today.getUTCDate() + 1,
  );

  return vDay < tomorrowDay;
};

export const isNumber = (value: string | number): boolean => {
  return (
    value !== null &&
    value !== undefined &&
    value !== '' &&
    !isNaN(Number(value.toString()))
  );
};

const yearAccurate = (value: number | null | undefined) => {
  if (!value) {
    return true;
  }

  const todayYear = new Date().getFullYear();
  return value <= todayYear + 2 && value >= todayYear - 2;
};

export const symbolRequiredWhenNotMain = (
  symbol?: string | null,
  main?: boolean | null,
) => {
  if (!main && !symbol) {
    return false;
  } else {
    return true;
  }
};

export const NipSchema = yup.object().shape({
  nip: yup.string().nullable().required('Proszę podać numer NIP.'),
  // .test('valid nip', 'Podany NIP jest niepoprawny.', validNip),
});

export const HarmfulFactorSchema = yup.object().shape({
  name: yup
    .string()
    .nullable()
    .required('Proszę podać nazwę czynnika szkodliwego.'),
});

export const SupportingExaminationDictSchema = yup.object().shape({
  name: yup
    .string()
    .nullable()
    .required('Proszę podać nazwę badania pomocniczego.'),
  type: yup
    .string()
    .nullable()
    .required('Proszę wybrać typ badania pomocniczego.'),
});

export const SupportingExaminationSchema = yup.object().shape({
  examKindDictId: yup
    .string()
    .nullable()
    .required('Brak rodzaju badania pomocniczego.'),
  doctorUid: yup
    .string()
    .nullable()
    .when('printReferral', {
      is: true,
      then: schema =>
        schema.required(
          'Brak lekarza kierującego. Wybierz lekarza przed zapisem skierowania.',
        ),
    }),
  referralDate: yup
    .date()
    .nullable()
    .required('Brak daty skierowania. Data skierowania jest wymagana.'),
});

export const PricingGroupSchema = yup.object().shape({
  name: yup.string().nullable().required('Proszę podać nazwę grupy cenowej.'),
});

export const FiscalPrinterLocationSchema = yup.object().shape({
  printerUid: yup.string().nullable().required('Proszę podać UID drukarki.'),
});

export const InvoiceIssuerSchema = yup.object().shape({
  name: yup.string().nullable().required('Proszę podać nazwę wystawcy.'),
  nip: yup
    .string()
    .nullable()
    .test('nip not valid', 'Podany NIP jest niepoprawny.', isNipValid),
  address: yup.string().nullable().required('Proszę podać adres wystawcy.'),
  symbol: yup.string().nullable().required('Proszę podać symbol faktury.'),
  symbolCorrection: yup
    .string()
    .nullable()
    .required('Proszę podać symbol korekty.'),
});

export const DutySchema = yup.object().shape({
  name: yup
    .string()
    .nullable()
    .required('Proszę podać nazwę grupy dyżurującej.'),
});

export const ManualSchema = yup.object().shape({
  name: yup.string().required('Nazwa jest wymagana'),
  description: yup.string().nullable(),
  testsIds: yup.array(yup.string()).nullable(),
  attachmentsToDelete: yup.array(yup.string()).nullable(),
  attachments: yup.array().nullable(),
});

export const peselOrCardValidation = function (values: {
  pesel?: string | null;
  iDCardNumber?: string | null;
  iDCardType?: string | null;
  idCardTypeDictId?: string | null;
  countryId?: string | null;
}) {
  const { pesel, iDCardNumber, iDCardType, idCardTypeDictId, countryId } =
    values;
  const hasCardType = !!(iDCardType || idCardTypeDictId);
  if (!pesel && !iDCardNumber && !hasCardType && !countryId) {
    return false;
  }

  return true;
};

const idAndTypeCardValidation = function (values: {
  pesel?: string | null;
  iDCardNumber?: string | null;
  iDCardType?: string | null;
  idCardTypeDictId?: string | null;
  countryId?: string | null;
}) {
  const { iDCardNumber, iDCardType, idCardTypeDictId, countryId } = values;
  const hasCardType = !!(iDCardType || idCardTypeDictId);
  const anyFilled = !!iDCardNumber || hasCardType || !!countryId;
  const allFilled = !!iDCardNumber && hasCardType && !!countryId;

  if (anyFilled && !allFilled) {
    return false;
  }

  return true;
};

// Base examined schema without PESEL validation
export const BaseExaminedSchema = yup.object().shape({
  firstname: yup.string().nullable().required('Proszę podać imię badanego.'),
  surname: yup.string().nullable().required('Proszę podać nazwisko badanego.'),
  dateOfBirth: yup
    .date()
    .transform(value => (isNaN(value) ? undefined : value))
    .required('Proszę podać datę urodzenia.')
    .test('not future', 'Data urodzin nie może być przyszła.', dateNotFuture),
  email: yup
    .string()
    .required('Proszę podać adres e-mail badanego.')
    .test({
      name: 'emails',
      test: function (value) {
        const firstInvalidEmail =
          value &&
          value
            .split(',')
            .map(email => email.trim())
            .filter(v => v.length > 0)
            .find(v => !isEmailSchema.isValidSync(v));

        return !firstInvalidEmail
          ? true
          : this.createError({
              message: `Adres e-mail: '${firstInvalidEmail}' jest niepoprawny. Kilka adresów proszę rozdzielić przecinkiem. `,
            });
      },
    }),
  nip: yup
    .string()
    .nullable()
    .test('nip not valid', 'Podany NIP jest niepoprawny.', isNipValid),
  invoiceName: yup.string().nullable(),
  invoiceAddress: yup.string().nullable(),
});

// PESEL validation schema
export const PeselValidationSchema = {
  pesel: yup
    .string()
    .nullable()
    .test(
      'only digits in pesel',
      'Numer PESEL powinien się składać wyłącznie z cyfr.',
      digitsOnly,
    )
    .test('pesel not valid', 'Podany PESEL jest niepoprawny.', isPeselValid)
    .test(
      'pesel and birthday not match',
      'Data urodzenia niezgodna z numerem PESEL.',
      function (item) {
        return isPeselAndBirthDateValid(item, this.parent.dateOfBirth);
      },
    ),
};

// Complete schema with PESEL validation
export const ExaminedSchema = BaseExaminedSchema.clone()
  .shape(
    {
      ...PeselValidationSchema,
    },
    [['iDCardNumber', 'idCardTypeDictId, countryId']],
  )
  .test(
    'idCard-and-typeCard',
    'Proszę podać numer, nazwę i kraj wydania dokumentu stwierdzającego tożsamość.',
    idAndTypeCardValidation,
  );

// const isEmailSchema = yup.string().email();
const isEmailSchema = yup
  .string()
  .matches(
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~ĄĆĘŁŃÓŚŹŻąćęłńóśźż-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    'Nieprawidłowy adres e-mail',
  );

export const TestSchema = yup.object().shape({
  name: yup.string().nullable().required('Proszę podać nazwę testu.'),
  description: yup.string().nullable().required('Proszę podać opis testu.'),
  identifier: yup
    .string()
    .nullable()
    .required('Proszę podać unikalny identyfikator testu.'),
  fileName: yup
    .string()
    .nullable()
    .matches(/^.*\.(json)$/, 'Nazwa pliku musi mieć rozszerzenie .json')
    .required('Proszę podać nazwę pliku z testem.'),
});

export const ArticleSchema = yup.object().shape({
  lp: yup.number().nullable().required('Proszę podać lp podstawy prawnej.'),
  description: yup
    .string()
    .nullable()
    .required('Proszę podać opis podstawy prawnej.'),
  legalBasis: yup.string().nullable().required('Proszę podać podstawę prawną.'),
  reason: yup.string().nullable().required('Proszę podać powód.'),
  pdfTemplateType: yup
    .mixed<TemplateType>()
    .oneOf(Object.values(TemplateType))
    .nullable()
    .required('Proszę wybrać szablon wydruku.'),
  engPdfTemplateType: yup
    .mixed<TemplateType>()
    .oneOf(Object.values(TemplateType))
    .nullable(),
});

export const JudgmentNumberingSchema = yup.object().shape({
  type: yup
    .mixed<JudgmentNumberingTypeEnum>()
    .oneOf(Object.values(JudgmentNumberingTypeEnum))
    .required('Proszę podać typ numeracji.'),
  registerId: yup
    .string()
    .nullable()
    .when('type', {
      is: JudgmentNumberingTypeEnum.Judgment,
      then: schema =>
        schema.required(
          'Proszę podać rejestr, którego dotyczy numeracja orzeczeń.',
        ),
      otherwise: schema => schema.nullable(),
    }),
  actualNumber: yup
    .string()
    .nullable()
    .required('Proszę podać aktualny numer orzeczeń.'),
  year: yup
    .number()
    .nullable()
    .required('Proszę podać rok, którego dotyczy numeracja orzeczeń.')
    .test(
      'year accurate',
      'Wprowadzony rok jest za bardzo z przyszłości lub przeszłości. Proszę wprowadzić poprawny rok numeracji.',
      yearAccurate,
    ),
});

const isDateNotEarlierThan = (
  date: Date | null | undefined,
  reference: unknown,
): boolean => {
  if (!date || !reference) {
    return true;
  }
  const d = new Date(date);
  const r = new Date(reference as Date);
  d.setHours(0, 0, 0, 0);
  r.setHours(0, 0, 0, 0);
  return d >= r;
};

export const JudgmentSchema = yup.object().shape({
  psychologistUID: yup
    .string()
    .nullable()
    .required('Proszę wybrać lekarza/psychologa.'),
  nextExamDate: yup
    .date()
    .nullable()
    .test(
      'nextExamDateAfterJudgmentDate',
      'Data następnego badania nie może być wcześniejsza niż data orzeczenia.',
      function (value) {
        return isDateNotEarlierThan(value, this.parent.judgmentDate);
      },
    ),
});

export const CardSchema = yup.object().shape({
  nextExamDate: yup
    .date()
    .nullable()
    .test(
      'nextExamDateAfterCardDate',
      'Data następnego badania nie może być wcześniejsza niż data karty.',
      function (value) {
        return isDateNotEarlierThan(value, this.parent.cardDate);
      },
    ),
});

export const UserSchema = yup.object().shape({
  name: yup
    .string()
    .nullable()
    .required('Proszę podać imię i nazwisko użytkownika.'),
  email: yup
    .string()
    .email('Niepoprawny adres e-mail')
    .nullable()
    .required('Proszę podać adres e-mail.'),
});

export const BatterySchema = yup.object().shape({
  name: yup.string().nullable().required('Proszę podać nazwę.'),
  tests: yup.array().min(1, 'Proszę przypisać co najmniej jeden test.'),
});

export const NormSchema = yup.object().shape({
  description: yup.string().nullable().required('Proszę podać nazwę normy.'),
});

export const IndicatorTestSchema = yup.object().shape({
  description: yup
    .string()
    .nullable()
    .required('Proszę podać nazwę wskaźnika.'),
});

export const KeyTestSchema = yup.object().shape({
  description: yup.string().nullable().required('Proszę podać nazwę klucza.'),
});

export const AttachmentSchema = yup.object().shape({
  name: yup.string().nullable().required('Proszę wskazać plik załącznika.'),
});

const EU_VAT_PATTERNS: Record<string, RegExp> = {
  AT: /^U\d{8}$/i,
  BE: /^\d{9,10}$/,
  BG: /^\d{9,10}$/,
  CY: /^\d{8}[A-Z]$/i,
  CZ: /^\d{8,10}$/,
  DE: /^\d{9}$/,
  DK: /^\d{8}$/,
  EE: /^\d{9}$/,
  EL: /^\d{9}$/,
  ES: /^[A-Z0-9]\d{7}[A-Z0-9]$/i,
  FI: /^\d{8}$/,
  FR: /^[A-Z0-9]{2}\d{9}$/i,
  HR: /^\d{11}$/,
  HU: /^\d{8}$/,
  IE: /^\d{7}[A-Z]{1,2}$/i,
  IT: /^\d{11}$/,
  LT: /^(\d{9}|\d{12})$/,
  LU: /^\d{8}$/,
  LV: /^\d{11}$/,
  MT: /^\d{8}$/,
  NL: /^\d{9}B\d{2}$/i,
  PT: /^\d{9}$/,
  RO: /^\d{2,10}$/,
  SE: /^\d{12}$/,
  SI: /^\d{8}$/,
  SK: /^\d{10}$/,
};

export const stripEuVatPrefix = (
  identifier: string | null | undefined,
  countryCode: string | null | undefined,
): string | null => {
  if (!identifier) {
    return null;
  }
  const upper = identifier.toUpperCase();
  if (countryCode && upper.startsWith(countryCode.toUpperCase())) {
    return identifier.substring(countryCode.length);
  }
  return identifier;
};

export const isEuVatValid = (
  identifierRaw: string | null | undefined,
  countryCode?: string | null,
): boolean => {
  if (!identifierRaw) {
    return true;
  }
  const stripped = identifierRaw.replace(/[\s-]/g, '').toUpperCase();
  const code =
    countryCode?.toUpperCase() ??
    (/^[A-Z]{2}/.test(stripped) ? stripped.substring(0, 2) : null);
  if (!code) {
    return true;
  }
  const pattern = EU_VAT_PATTERNS[code];
  if (!pattern) {
    return true;
  } // nieznany kraj — pomijamy walidację
  const identifier = stripEuVatPrefix(stripped, code) ?? stripped;
  return pattern.test(identifier);
};

export const CompanySchema = yup
  .object()
  .shape({
    name: yup.string().nullable().required('Proszę podać nazwę firmy.'),
    nip: yup
      .string()
      .nullable()
      .test('nip not valid', 'Podany NIP jest niepoprawny.', isNipValid),
    taxIdentifier: yup.string().nullable(),
    taxCountryCodeShortname: yup.string().nullable(),
    taxCountryCodeId: yup.string().when('taxIdentifier', {
      is: (val: string) => !!val?.trim(),
      then: schema =>
        schema
          .nullable()
          .required(
            'Proszę wskazać kod kraju nadania identyfikatora podatkowego.',
          ),
      otherwise: schema => schema.nullable(),
    }),
    invoicePaymentDays: yup
      .number()
      .nullable()
      .typeError('Liczba dni płatności musi być liczbą.')
      .integer('Liczba dni płatności musi być liczbą całkowitą.')
      .min(0, 'Liczba dni płatności nie może być ujemna.')
      .max(90, 'Liczba dni płatności nie może przekraczać 90.'),
    email: yup.string().when('externalReferral', {
      is: (val: boolean) => val === true,
      then: schema =>
        schema
          .nullable()
          .required(
            'Proszę wskazać e-mail, na który będą wysyłane dodatkowo skierowania tworzone przez pracowników tej firmy.',
          ),
      otherwise: schema => schema.nullable(),
    }),
  })
  .test(
    'nip-or-tax-identifier-not-both',
    'Nie można podać jednocześnie NIP i identyfikatora podatkowego.',
    function (values) {
      const { nip, taxIdentifier } = values;
      if (nip && taxIdentifier) {
        return false;
      }
      return true;
    },
  );

export const HealthcareFacilitySchema = yup.object().shape({
  nameDoctor: yup
    .string()
    .nullable()
    .required('Proszę podać nazwę placówki lekarskiej.'),
  namePsychological: yup
    .string()
    .nullable()
    .required('Proszę podać nazwę placówki psychologicznej.'),
  displayName: yup
    .string()
    .nullable()
    .required('Proszę podać wyświetlaną w systemie nazwę placówki.'),
  city: yup.string().nullable().required('Proszę podać miejscowość.'),
  address: yup.string().nullable().required('Proszę podać adres.'),
  nip: yup
    .string()
    .nullable()
    .required('Proszę podać nip placówki lekarskiej.'),
  nipPsychological: yup
    .string()
    .nullable()
    .required('Proszę podać nip placówki psychologicznej.'),
  regon: yup
    .string()
    .nullable()
    .required('Proszę podać regon placówki lekarskiej.'),
  regonPsychological: yup
    .string()
    .nullable()
    .required('Proszę podać regon placówki psychologicznej.'),
  entryContentPsychological: yup
    .string()
    .nullable()
    .required('Proszę podać wpis drukowany na orzeczeniach psychologicznych.'),
  entryContentDoctor: yup
    .string()
    .nullable()
    .required('Proszę podać wpis drukowany na orzeczeniach lekarskich.'),
});

export const ExamForExternalReferralSchema = yup.object().shape({
  employmentPosition: yup.string().when('whoExamined', {
    is: (val: string) => val === 'Employee',
    then: schema =>
      schema.nullable().required('Proszę podać stanowisko pracownika.'),
    otherwise: schema => schema.nullable(),
  }),
  employerName: yup.string().when('whoExamined', {
    is: (val: string) => val === 'Employee',
    then: schema =>
      schema.nullable().required('Proszę podać nazwę pracodawcy.'),
    otherwise: schema => schema.nullable(),
  }),
  employerAddress: yup.string().when('whoExamined', {
    is: (val: string) => val === 'Employee',
    then: schema =>
      schema.nullable().required('Proszę podać adres pracodawcy.'),
    otherwise: schema => schema.nullable(),
  }),
  schoolName: yup.string().when('whoExamined', {
    is: (val: string) => val === 'Student',
    then: schema =>
      schema.nullable().required('Proszę podać nazwę placówki dydaktycznej.'),
    otherwise: schema => schema.nullable(),
  }),
  schoolAddress: yup.string().when('whoExamined', {
    is: (val: string) => val === 'Student',
    then: schema =>
      schema.nullable().required('Proszę podać adres placówki dydaktycznej.'),
    otherwise: schema => schema.nullable(),
  }),
  kindOfScience: yup.string().when('whoExamined', {
    is: (val: string) => val === 'Student',
    then: schema =>
      schema.nullable().required('Proszę wybrać rodzaj nauki lub kształcenia.'),
    otherwise: schema => schema.nullable(),
  }),
  fieldOfStudy: yup.string().when('whoExamined', {
    is: (val: string) => val === 'Student',
    then: schema =>
      schema
        .nullable()
        .required(
          'Proszę podać kierunek praktycznej nauki zawodu lub kształcenia.',
        ),
    otherwise: schema => schema.nullable(),
  }),
  endScience: yup.date().when('whoExamined', {
    is: (val: string) =>
      val === 'Student' ||
      val === 'StudentAndSanitary' ||
      val === 'SanitaryStudent',
    then: schema =>
      schema
        .nullable()
        .required('Proszę podać datę końca nauki.')
        .test(
          'not-past',
          'Data końca nauki nie może być z przeszłości.',
          value => !value || value >= new Date(new Date().setHours(0, 0, 0, 0)),
        ),
    otherwise: schema => schema.nullable(),
  }),
  schoolCandidate: yup.boolean().when('whoExamined', {
    is: (val: string) =>
      val === 'Student' ||
      val === 'StudentAndSanitary' ||
      val === 'SanitaryStudent',
    then: schema =>
      schema
        .nullable()
        .required(
          'Proszę wybrać czy badany jest uczniem czy kandydatem na ucznia.',
        ),
    otherwise: schema => schema.nullable(),
  }),
  employmentCandidate: yup.boolean().when('whoExamined', {
    is: (val: string) =>
      val === 'Employee' || val === 'Sanitary' || val === 'EmployeeAndSanitary',
    then: schema =>
      schema
        .nullable()
        .required(
          'Proszę wybrać czy badany jest pracownikiem czy kandydatem do pracy.',
        ),
    otherwise: schema => schema.nullable(),
  }),
  employeePeriod: yup.string().when(['whoExamined', 'employmentCandidate'], {
    is: (whoExamined: string, employmentCandidate: boolean) =>
      (whoExamined === 'Employee' ||
        whoExamined === 'Sanitary' ||
        whoExamined === 'EmployeeAndSanitary') &&
      employmentCandidate === false,
    then: schema =>
      schema.nullable().required('Proszę podać okres zatrudnienia.'),
    otherwise: schema => schema.nullable(),
  }),
  schoolPeriod: yup.string().when(['whoExamined', 'schoolCandidate'], {
    is: (whoExamined: string, schoolCandidate: boolean) =>
      (whoExamined === 'Student' ||
        whoExamined === 'StudentAndSanitary' ||
        whoExamined === 'SanitaryStudent') &&
      schoolCandidate === false,
    then: schema => schema.nullable().required('Proszę podać okres nauki.'),
    otherwise: schema => schema.nullable(),
  }),
  type: yup.string().nullable().required('Proszę wybrać rodzaj skierowania.'),
});

export const ExamTypeCategorySchema = yup.object().shape({
  name: yup
    .string()
    .nullable()
    .required('Proszę podać nazwę kategorii typów badań.'),
});

export const ExamTypeSchema = yup.object().shape({
  name: yup.string().nullable().required('Proszę podać nazwę typu badania.'),
  description: yup
    .string()
    .nullable()
    .required('Proszę podać opis typu badania.'),
  categoryId: yup
    .string()
    .nullable()
    .required('Proszę wybrać kategorię badania.'),
  price: yup
    .number()
    .nullable()
    .typeError('Proszę podać cenę badania.')
    .required('Proszę podać cenę badania.')
    .min(1, 'Proszę podać cenę badania.'),
  online: yup
    .boolean()
    .nullable()
    .required('Proszę określić, czy badanie jest dostępne online.'),
  onlinePayment: yup
    .boolean()
    .nullable()
    .test(
      'online-payment-check',
      'Typ badania dostępny online musi mieć włączoną płatność online.',
      function (value) {
        return !this.parent.online || value === true;
      },
    ),
});

export const AppointmentChannelSchema = yup.object().shape({
  name: yup.string().nullable().required('Proszę podać nazwę kanału.'),
  description: yup.string().nullable().required('Proszę podać opis kanału.'),
  healthcareFacilityId: yup
    .string()
    .nullable()
    .required('Proszę wybrać placówkę medyczną.'),
  timeWindow: yup
    .number()
    .typeError('Proszę podać okno czasowe (liczbę minut).')
    .required('Proszę podać okno czasowe (liczbę minut).')
    .positive('Okno czasowe (liczba minut) musi być większe od 0.')
    .integer('Okno czasowe musi być liczbą całkowitą.'),
});

export const ExaminedWithoutPeselSchema = BaseExaminedSchema.clone().shape({
  pesel: yup.string().nullable(),
  iDCardNumber: yup.string().nullable(),
  iDCardType: yup.string().nullable(),
});

export const ExternalReferralSchema = yup.object().shape({
  examined: ExaminedSchema.test(
    'pesel-or-card',
    'Proszę podać numer PESEL lub nazwę, numer i kraj wydania dokumentu stwierdzającego tożsamość.',
    peselOrCardValidation,
  ),
  examWithTests: ExamForExternalReferralSchema,
});

export const ExternalReferralWithoutPeselSchema = yup.object().shape({
  examined: ExaminedWithoutPeselSchema,
  examWithTests: ExamForExternalReferralSchema,
});

export const VisitRegistrationSchema = yup.object().shape({
  firstname: yup.string().nullable().required('Proszę podać imię.'),
  surname: yup.string().nullable().required('Proszę podać nazwisko.'),
  visitDateTime: yup
    .string()
    .nullable()
    .when('online', {
      is: (val: boolean) => val === true,
      then: schema => schema.nullable(),
      otherwise: schema =>
        schema.required('Proszę podać termin rozpoczęcia wizyty.'),
    }),
  phone: yup.string().nullable(),
  appointmentChannelId: yup
    .string()
    .nullable()
    .when('online', {
      is: (val: boolean) => val === true,
      then: schema => schema.nullable(),
      otherwise: schema => schema.required('Proszę wybrać kanał rejestracji.'),
    }),
  mail: yup
    .string()
    .required('Proszę podać adres e-mail.')
    .test({
      name: 'emails',
      test: function (value) {
        const firstInvalidEmail =
          value &&
          value
            .split(',')
            .map(email => email.trim())
            .filter(v => v.length > 0)
            .find(v => !isEmailSchema.isValidSync(v));

        return !firstInvalidEmail
          ? true
          : this.createError({
              message: `Adres e-mail: '${firstInvalidEmail}' jest niepoprawny. Kilka adresów proszę rozdzielić przecinkiem. `,
            });
      },
    }),
});

export const JobConfigSchema = yup.object().shape({
  type: yup
    .mixed<JobTypeEnum>()
    .oneOf(Object.values(JobTypeEnum))
    .required('Wybierz konfigurację'),
  crone: yup.string().nullable().required('Wybierz częstotliwość'),
});

export const DictionarySchema = yup.object().shape({
  value: yup.string().nullable().required('Proszę podać wartość słownika.'),
});

const salesInvoicePositionBaseShape = {
  name: yup.string().required('Proszę podać nazwę pozycji.'),
  amount: yup
    .number()
    .typeError('Proszę podać kwotę.')
    .nullable()
    .required('Proszę podać kwotę.'),
  vat: yup
    .mixed<VatEnum>()
    .oneOf(Object.values(VatEnum))
    .required('Proszę wybrać stawkę VAT.'),
};

export const SalesInvoicePositionSchema = yup.object().shape({
  ...salesInvoicePositionBaseShape,
  amount: yup
    .number()
    .typeError('Proszę podać kwotę.')
    .min(0, 'Kwota pozycji musi być liczbą nieujemną.')
    .nullable()
    .required('Proszę podać kwotę.'),
  quantity: yup
    .number()
    .typeError('Ilość musi być liczbą.')
    .integer('Ilość musi być liczbą całkowitą.')
    .min(0, 'Ilość musi być liczbą nieujemną.')
    .nullable(),
});

export const SalesInvoiceCorrectionPositionSchema = yup.object().shape({
  ...salesInvoicePositionBaseShape,
  quantity: yup
    .number()
    .typeError('Ilość musi być liczbą.')
    .integer('Ilość musi być liczbą całkowitą.')
    .nullable(),
});

export const SalesInvoiceSchema = yup
  .object()
  .shape({
    invoiceDate: yup
      .date()
      .transform(value => (isNaN(value) ? undefined : value))
      .required('Proszę podać datę wystawienia.'),
    saleDate: yup
      .date()
      .transform(value => (isNaN(value) ? undefined : value))
      .required('Proszę podać datę sprzedaży.'),
    dueDate: yup
      .date()
      .transform(value => (isNaN(value) ? undefined : value))
      .required('Proszę podać termin płatności.'),
    isPaid: yup.boolean(),
    paidDate: yup
      .date()
      .transform(value => (isNaN(value) ? undefined : value))
      .nullable()
      .test(
        'not future',
        'Data opłacenia nie może być z przyszłości.',
        dateNotFuture,
      )
      .when('isPaid', {
        is: true,
        then: schema => schema.required('Proszę podać datę opłacenia.'),
        otherwise: schema => schema.optional(),
      }),
    companyId: yup.string().nullable(),
    examinedId: yup.string().nullable(),
    issuerId: yup.string().nullable(),
    recipientId: yup.string().nullable(),
    recipientRole: yup
      .string()
      .nullable()
      .when('recipientId', {
        is: (val: string | null | undefined) => !!val,
        then: schema => schema.required('Proszę wybrać rolę odbiorcy.'),
        otherwise: schema => schema.nullable(),
      }),
    recipientIdWew: yup
      .string()
      .nullable()
      .matches(
        /^[1-9]((\d[1-9])|([1-9]\d))\d{7}-\d{5}$/,
        'IDWew musi mieć format: NIP (10 cyfr) + myślnik + 5 cyfr, np. 1234567890-00001.',
      ),
    recipientRoleDescription: yup
      .string()
      .nullable()
      .max(256, 'Opis roli może mieć maksymalnie 256 znaków.')
      .when('recipientRole', {
        is: (val: string | null | undefined) => val === 'OtherEntity',
        then: schema => schema.required('Proszę podać opis roli.'),
        otherwise: schema => schema.nullable(),
      }),
    recipientShare: yup
      .number()
      .nullable()
      .min(0, 'Udział nie może być ujemny.')
      .max(100, 'Udział nie może przekraczać 100%.'),
    companyNip: yup.string().nullable(),
    companyTaxIdentifier: yup.string().nullable(),
    examinedNip: yup.string().nullable(),
    companyAddress: yup.string().nullable(),
    examinedAddress: yup.string().nullable(),
  })
  .test(
    'company-or-examined',
    'Proszę wybrać firmę lub badanego.',
    function (values) {
      const { companyId, examinedId } = values;
      // Musi być albo companyId albo examinedId
      if (!companyId && !examinedId) {
        return false;
      }
      return true;
    },
  )
  .test(
    'not-both-company-and-examined',
    'Nie można wybrać jednocześnie firmy i badanego.',
    function (values) {
      const { companyId, examinedId } = values;
      // Nie mogą być oba równocześnie
      if (companyId && examinedId) {
        return false;
      }
      return true;
    },
  )
  .test(
    'company-nip-valid',
    'Firma musi mieć poprawny NIP, aby wystawić fakturę.',
    function (values) {
      const { companyId, companyNip, companyTaxIdentifier } = values;
      if (!companyId) {
        return true;
      }
      if (!companyNip && !companyTaxIdentifier) {
        return this.createError({
          message:
            'Firma musi mieć podany NIP lub identyfikator podatkowy, aby wystawić fakturę.',
        });
      }
      if (companyNip && !isNipValid(companyNip)) {
        return this.createError({
          message: 'Firma musi mieć poprawny NIP, aby wystawić fakturę.',
        });
      }
      return true;
    },
  )
  .test('examined-nip-valid', 'Badany ma niepoprawny NIP.', function (values) {
    const { examinedId, examinedNip } = values;
    if (!examinedId) {
      return true;
    }
    if (!examinedNip) {
      return true;
    }
    return isNipValid(examinedNip);
  })
  .test(
    'company-address-required',
    'Firma musi mieć podany adres, aby wystawić fakturę.',
    function (values) {
      const { companyId, companyAddress } = values;
      if (!companyId) {
        return true;
      }
      return !!companyAddress && companyAddress.trim().length > 0;
    },
  )
  .test(
    'examined-address-required',
    'Badany musi mieć podany adres, aby wystawić fakturę.',
    function (values) {
      const { examinedId, examinedAddress } = values;
      if (!examinedId) {
        return true;
      }
      return !!examinedAddress && examinedAddress.trim().length > 0;
    },
  );

const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;

export const CertificateGenerateSchema = yup.object().shape({
  commonName: yup
    .string()
    .nullable()
    .required('Common Name jest wymagane')
    .matches(ipv4Regex, 'Common Name musi być w formacie IP (np. 192.168.1.1)'),
  password: yup.string().nullable().required('Hasło jest wymagane'),
});

export const CertificatePasswordSchema = yup.object().shape({
  password: yup.string().nullable().required('Hasło jest wymagane'),
});

export const ReceiptItemSchema = yup.object().shape({
  name: yup.string().required('Proszę podać nazwę pozycji.'),
  quantity: yup
    .number()
    .typeError('Ilość musi być liczbą.')
    .min(1, 'Ilość musi być większa od 0.')
    .required('Proszę podać ilość.'),
  price: yup.string().required('Proszę podać cenę pozycji.'),
  vat: yup.string().required('Proszę wybrać stawkę VAT.'),
});

export const ExamPaymentSchema = yup.object().shape({
  paymentDate: yup
    .date()
    .transform(value => (isNaN(value) ? undefined : value))
    .nullable()
    .test(
      'not future',
      'Data płatności nie może być z przyszłości.',
      dateNotFuture,
    ),
});

export const InvoicePaymentSchema = yup.object().shape({
  amount: yup
    .string()
    .nullable()
    .required('Kwota wpłaty jest wymagana.')
    .test(
      'greater-than-zero',
      'Kwota wpłaty musi być większa od zera.',
      value => !value || (isNumber(value) && Number(value) > 0),
    ),
  paymentDate: yup
    .date()
    .transform(value => (isNaN(value) ? undefined : value))
    .nullable()
    .required('Data wpłaty jest wymagana.')
    .test(
      'not future',
      'Data wpłaty nie może być z przyszłości.',
      dateNotFuture,
    ),
});

export const GenerateReceiptSchema = yup.object().shape({
  examId: yup.string().required('ID badania jest wymagane.'),
  paymentMethod: yup.string().required('Metoda płatności jest wymagana.'),
  items: yup
    .array()
    .of(ReceiptItemSchema)
    .min(1, 'Co najmniej jedna pozycja paragonu jest wymagana.'),
});

export const ParamsSchema = yup.object().shape({
  isEditable: yup
    .boolean()
    .nullable()
    .test(
      'is-editable',
      'Parametr nie jest edytowalny.',
      value => value === true,
    ),
  type: yup.string().nullable().required('Proszę wybrać typ parametru.'),
  valueString: yup.string().when('type', {
    is: ParamsTypeEnum.String,
    then: schema =>
      schema.nullable().required('Proszę podać wartość tekstową.'),
    otherwise: schema => schema.nullable(),
  }),
  valueBoolean: yup.boolean().when('type', {
    is: ParamsTypeEnum.Boolean,
    then: schema =>
      schema.nullable().required('Proszę podać wartość logiczną.'),
    otherwise: schema => schema.nullable(),
  }),
  valueNumber: yup.number().when('type', {
    is: ParamsTypeEnum.Number,
    then: schema =>
      schema
        .nullable()
        .typeError('Proszę podać wartość liczbową.')
        .required('Proszę podać wartość liczbową.'),
    otherwise: schema => schema.nullable(),
  }),
  valueDate: yup.date().when('type', {
    is: ParamsTypeEnum.Date,
    then: schema =>
      schema
        .nullable()
        .transform(value => (isNaN(value) ? undefined : value))
        .required('Proszę podać wartość datową.'),
    otherwise: schema => schema.nullable(),
  }),
});

export const ExamBlockSchema = yup.object().shape({
  reason: yup.string().nullable().required('Przyczyna blokady jest wymagana.'),
});

export const MAX_CANCELLATION_REASON_LENGTH = 500;

export const CancelJudgmentSchema = yup.object().shape({
  reason: yup
    .string()
    .trim()
    .nullable()
    .max(
      MAX_CANCELLATION_REASON_LENGTH,
      `Powód anulowania może mieć maksymalnie ${MAX_CANCELLATION_REASON_LENGTH} znaków.`,
    ),
});
